import React, { useState } from "react";

interface IdInputProps {
    setReady: React.Dispatch<React.SetStateAction<boolean>>;
    setUserId: React.Dispatch<React.SetStateAction<string>>;
}

const IdInput: React.FC<IdInputProps> = ({ setReady, setUserId }) => {
    const [idValue, setIdValue] = useState("");
    const [showTooltip, setShowTooltip] = useState(false);

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length > 0) {
            setUserId(e.target.value);
            setReady(true);
        } else {
            setReady(false);
        }
        setIdValue(e.target.value);        
    }

    return (
        <div className="InputWrapper">
            <div className="InputLabelWrapper">
                <span className="InputLable">Введите код для регистрации:</span>
            </div>
            <div className="TooltipContainer">
                <input
                    type="text"
                    id="idInput"
                    value={idValue}
                    onChange={onInputChange}
                    onFocus={() => setShowTooltip(true)}
                    onBlur={() => setShowTooltip(false)}
                />
                {showTooltip && (
                    <span id="tooltip" className="Tooltip">
                        Ваш табельный номер + 4 последние цифры вашего СНИЛС слитно
                    </span>
                )}
            </div>
        </div>
    );
}


export default IdInput;